module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/index.js
// module id = 167
// module chunks = 0 1 2